import { type ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useClientConfig } from "@/contexts/ClientConfigContext";
import { getClientPrimaryButtonStyle } from "@/lib/clientPrimaryButton";
import {
  MODAL_FOOTER_ACTIONS_CLASS,
  MODAL_FOOTER_DIVIDER_CLASS,
  MODAL_FOOTER_STICKY_MOBILE_CLASS,
  MODAL_FOOTER_WRAPPER_CLASS,
} from "@/lib/modalStyles";

type ModalPrimaryActionProps = {
  show: boolean;
  children: ReactNode;
  type?: "button" | "submit";
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  align?: "start" | "end" | "center";
  className?: string;
};

export function ModalPrimaryAction({
  show,
  children,
  type = "button",
  onClick,
  disabled = false,
  loading = false,
  align = "end",
  className = "",
}: ModalPrimaryActionProps) {
  const { config } = useClientConfig();
  const style = getClientPrimaryButtonStyle(config.primary_color);

  if (!show) return null;

  const alignClass =
    align === "start" ? "justify-start" : align === "center" ? "justify-center" : "justify-end";

  return (
    <div className={`${MODAL_FOOTER_WRAPPER_CLASS} ${MODAL_FOOTER_STICKY_MOBILE_CLASS}`}>
      <div className={MODAL_FOOTER_DIVIDER_CLASS} />
      <div className={`${MODAL_FOOTER_ACTIONS_CLASS} ${alignClass}`}>
        <Button
          type={type}
          onClick={onClick}
          disabled={disabled || loading}
          className={`w-auto shrink-0 text-sm hover:opacity-90 disabled:opacity-50 ${className}`.trim()}
          style={style}
        >
          {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
          {children}
        </Button>
      </div>
    </div>
  );
}
